const getDateYear = (value, options = {}) => {
    var re;
    // if timestamp option is not set, which means date is in date format
    if(!options.timestamp) {
        var datum = Date.parse(value);
        re = datum / 1000;
    }else {
        re = value;
    }
    function timeConverter(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var hour = a.getHours();
        var min = a.getMinutes();
        var sec = a.getSeconds();
        var time =
            date + " " + month + " " + year + " " + (options.hour === true ? hour + ":" : '') + (options.min === true ? min + ":" : '') + (options.sec === true ? sec : "");
            // apply as such :: this.$getDateYear(date)
            // add extra functions :: this.$getDateYear(date,{ hour: true, min: true, sec: true })
        return time;
    }
    return timeConverter(re);
}

export default getDateYear;